import types from "../actionTypes";
import {
  ERROR_TIMEOUT,
  DEFAULT_ERROR_MESSAGE,
  PREFERED_LANGUAGE_KEYS,
  userAdminCredential,
  USER_ROLES
} from "../../App.config";
import setLoaderAction from "./loaderAction";
import * as apiServices from "../../services/apiServices";
import * as toastAction from "../actions/toastAction";
import * as authAction from "../actions/userAuthAction";
import history from "../../utilities/history";
import { setManagerDetailsAction } from "./profileAction";
import { closeRemoveModal } from "./modalActions";
import * as utilities from "../../utilities/utils";
import { setLanguage } from "redux-i18n";
import swal from "sweetalert"

function sleep(ms, apiServices) {
  return new Promise((resolve) =>
    setTimeout(() => {
      resolve(apiServices);
    }, ms)
  );
}

/************************************ ACTIONS ****************************************/

function setIsAuthenticatingAction(isAuthenticating) {
  return {
    type: types.IS_AUTHENTICATING,
    isAuthenticating,
  };
}

function setIsAuthenticatedAction(isAuthenticated) {
  return {
    type: types.IS_AUTHENTICATED,
    isAuthenticated,
  };
}

function setIsAuthenticationFailedAction(isAuthenticationFailed) {
  return {
    type: types.IS_AUTHENTICATION_FAILED,
    isAuthenticationFailed,
  };
}

function setIsPasswordExpired(isPasswordExpired) {
  return {
    type: types.SET_IS_PASSWORD_EXPIRED,
    isPasswordExpired
  }
}

function setAuthToken(authToken) {
  return {
    type: types.SET_AUTH_TOKEN,
    authToken
  }
}

function setOnLoginModalNotification(isModalNotification) {
  return {
    type: types.SET_ON_LOGIN_MODALNOTIFICATION,
    isModalNotification
  }
}

function isLoginSuccessfullAction(isLogin) {
  return {
    type: types.SET_IS_LOGIN,
    isLogin
  }
}
/************************************ ACTION CREATORS ****************************************/

export const resetIsPasswordExpired = (isPasswordExpired) => (dispatch) => {
  dispatch(setIsPasswordExpired(isPasswordExpired));
}
export const resetOnLoginModalNotification = (isLoginModalNotification) => (dispatch) => {
  dispatch(setOnLoginModalNotification(isLoginModalNotification));
}

export const updateTnCStatus = (profileReducer, onSuccessAPI) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .updateTnCStatus(profileReducer.email)
    .then(({ data }) => {
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        history.push("dashboard");
        onSuccessAPI && onSuccessAPI();
      } else {
        // dispatch(setIsAuthenticationFailedAction(true));
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          // dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          // setTimeout(() => {
          //   dispatch(toastAction.showErrorMessage(false, ""));
          // }, ERROR_TIMEOUT);
          swal(data.errorMessage);
        }
        else {
          dispatch(setLoaderAction(false));
          // setTimeout(() => {
          //   dispatch(setIsAuthenticationFailedAction(false));
          // }, 5000);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
}

export const verifyUserOtp = (profileReducer, otp, openPasswordExpiryModal, onSuccessAPI, notificationReducer, showTnCPage) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .verifyUserOtp(profileReducer.email, otp)
    .then(({ data }) => {
      if (data.isTransactionSucceed
        && data.authToken
      ) {
        dispatch(setLoaderAction(false));
        // dispatch(setIsAuthenticatedAction(true));
        dispatch(setAuthToken(data.authToken));
        setTimeout(() => {
          // dispatch(setIsAuthenticatedAction(false));
          // dispatch(setManagerDetailsAction([]));
          // dispatch(setIsAuthenticationFailedAction(false));
          if (!profileReducer.isPasswordExpired) {
            // dispatch(setManagerDetailsAction(data.managerInformation));
            dispatch(setAuthToken(data.authToken));
            utilities.setToken(data.authToken);
            dispatch(authAction.getUserRolePermissions())
            dispatch(authAction.getUserCompanyServices())

            //Show terms and condition page for every login
            // if (!profileReducer.isConcent)
              showTnCPage && showTnCPage();
            // else
            //   history.push("dashboard")


            //history.push("/dashboard");
            // dispatch(
            //   setLanguage(
            //     data.managerInformation.languagePreference
            //       ? PREFERED_LANGUAGE_KEYS.FrenchCanada
            //       : PREFERED_LANGUAGE_KEYS.EnglishUS
            //   )
            // );
            // if(notificationReducer && notificationReducer.allPendingApplications.length>0)
            // swal("you have " + notificationReducer.allPendingApplications.length + " pending notification");
            dispatch(setOnLoginModalNotification(true));

          }
          else {
            dispatch(setIsPasswordExpired(false));
            dispatch(setManagerDetailsAction([]));
            openPasswordExpiryModal();
          }
          // onSuccessAPI();
        }, 2000);
      } else {
        // dispatch(setIsAuthenticationFailedAction(true));
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          // dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          // setTimeout(() => {
          //   dispatch(toastAction.showErrorMessage(false, ""));
          // }, ERROR_TIMEOUT);
          swal(data.errorMessage);
        }
        else {
          dispatch(setLoaderAction(false));
          // setTimeout(() => {
          //   dispatch(setIsAuthenticationFailedAction(false));
          // }, 5000);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
}

export const varifyLogin = (credentialDetails) => (dispatch) => {
  dispatch(setLoaderAction(true));
  dispatch(setIsAuthenticatingAction(true));
  // sleep(3000, apiServices.managerLogin).then((api) => {
  //   dispatch(setIsAuthenticatingAction(false));
  //   return api;
  // });
  if (
    credentialDetails.emailid === userAdminCredential.emailid &&
    credentialDetails.password === userAdminCredential.password
  ) {
    history.push("/company");
    utilities.setToken("user@admin.com");
    return;
  }
  return apiServices
    .managerLogin(credentialDetails)
    .then(({ data }) => {
      if (data.isTransactionSucceed
        // && data.authToken
      ) {
        dispatch(isLoginSuccessfullAction(true));
        dispatch(setLoaderAction(false));
        dispatch(setIsAuthenticatedAction(true));
        // dispatch(setAuthToken(data.authToken));
        setTimeout(() => {
          dispatch(setIsAuthenticatedAction(false));
          dispatch(setManagerDetailsAction([]));
          dispatch(setIsAuthenticationFailedAction(false));
          // if(data && data.managerInformation && (data.managerInformation.roleId==USER_ROLES.FULL_HR || data.managerInformation.roleId==USER_ROLES.LIMITED_CAL_HR || data.managerInformation.roleId==USER_ROLES.LIMITED_CAL_MGR )){
          //   let managerInformation = data.managerInformation;
          //   managerInformation.companyId = utilities.extractFirstValueOfArray(data.managerInformation.lstAssignedCompany); 
          //   dispatch(setManagerDetailsAction(managerInformation));
          // }
          // else{
          dispatch(setManagerDetailsAction(data.managerInformation));
          // }
          if (!data.managerInformation.isPasswordExpired) {
            // utilities.setToken(data.authToken);
            // history.push("/dashboard");
            // dispatch(authAction.getUserRolePermissions())
            // dispatch(authAction.getUserCompanyServices())


            dispatch(
              setLanguage(
                data.managerInformation.languagePreference
                  ? PREFERED_LANGUAGE_KEYS.FrenchCanada
                  : PREFERED_LANGUAGE_KEYS.EnglishUS
              )
            );
          }
          else
            dispatch(setIsPasswordExpired(true));
        }, 2000);
      } else {
        dispatch(setIsAuthenticationFailedAction(true));
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
        else {
          dispatch(setLoaderAction(false));
          setTimeout(() => {
            dispatch(setIsAuthenticationFailedAction(false));
          }, 5000);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};


export const changeExpiryPassword = (changePasswordInfo, authToken) => (dispatch) => {
  dispatch(setLoaderAction(true));
  // dispatch(setIsAuthenticatingAction(true));
  // sleep(3000, apiServices.managerLogin).then((api) => {
  //   dispatch(setIsAuthenticatingAction(false));
  //   return api;
  // });
  return apiServices
    .changeExpiryPassword(changePasswordInfo, authToken)
    .then(({ data }) => {
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        // dispatch(setIsAuthenticatedAction(true));
        dispatch(closeRemoveModal());
        dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
        // }, 2000);
      } else {
        dispatch(setIsAuthenticationFailedAction(true));
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
        else {
          dispatch(setLoaderAction(false));
          setTimeout(() => {
            dispatch(setIsAuthenticationFailedAction(false));
          }, 5000);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const isLoginSuccessfull = (isLogin) => (dispatch) => {
  dispatch(isLoginSuccessfullAction(isLogin));
}

